import { render, staticRenderFns } from "./StampCardsShow.vue?vue&type=template&id=ee8ca378&"
import script from "./StampCardsShow.vue?vue&type=script&lang=js&"
export * from "./StampCardsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports